import type { BillingContactField, ClientBillingContact } from '@avalara/types/billingContact';

export const isBillingContactFormValid = (state: ClientBillingContact) =>
  (Object.keys(state.validationErrors) as BillingContactField[]).every((field) => !state.validationErrors[field]);

export const isBillingContactUnchanged = ({ billingContactInfo, billingContactEditForm }: ClientBillingContact) =>
  (Object.keys(billingContactEditForm) as BillingContactField[]).every(
    (key) => billingContactEditForm[key] === billingContactInfo[key],
  );
